/**
 * English: org_id + station_id for agent-management APIs from URL scope (not chat org picker).
 * Thai: org_id และ station_id สำหรับ API agent-management จาก scope ใน URL
 */
import { useMemo } from 'react';
import { useAgentManagementScope } from '../../hooks/useAgentManagementScope';

export function useAgentManagementOrgContext(override?: {
  orgId?: string;
  stationId?: string;
}): { orgId: string; stationId: string } {
  const { stationId, resolvedOrgId } = useAgentManagementScope();

  return useMemo(
    () => ({
      orgId: override?.orgId?.trim() || resolvedOrgId,
      stationId: override?.stationId?.trim() || stationId,
    }),
    [override?.orgId, override?.stationId, resolvedOrgId, stationId],
  );
}
